// extracted by mini-css-extract-plugin
module.exports = {"btnLike":"LikeButton_btnLike__2n4IT","btnDefault":"LikeButton_btnDefault__hwZ57","likeCount":"LikeButton_likeCount__lfohu"};